var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle-button',{staticClass:"mb-0",attrs:{"width":35,"height":20,"value":_vm.hasLeaderboard(),"sync":true,"color":{checked: '#6A1EBB', unchecked: '#D3D7E1'}},on:{"change":function($event){return _vm.handleToggleLeaderboard()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }